import HttpClient from '../httpClient';

export interface InAppNotificationItem {
  sortKey: string;
  title: string;
  body: string;
  ctaUrl?: string;
  read: boolean;
  createdAt: number;
  preferenceKey: string;
}

export interface ListInAppNotificationsResult {
  notifications: InAppNotificationItem[];
  unreadCount: number;
  nextCursor?: string;
}

class NotificationsController extends HttpClient {
  list = async (
    orgId: string,
    token: string,
    params?: { limit?: number; cursor?: string | null },
  ) => {
    const response = await this.client.get(`/user/notifications/${orgId}`, {
      headers: { Authorization: token },
      params: {
        limit: params?.limit,
        cursor: params?.cursor || undefined,
      },
    });
    return response.data?.data as ListInAppNotificationsResult;
  };

  markRead = async (
    orgId: string,
    token: string,
    sortKey: string,
    read: boolean,
  ) => {
    await this.client.patch(
      `/user/notifications/${orgId}`,
      { sortKey, read },
      { headers: { Authorization: token } },
    );
  };

  deleteOne = async (orgId: string, token: string, sortKey: string) => {
    await this.client.post(
      `/user/notifications/${orgId}/delete`,
      { sortKey },
      { headers: { Authorization: token } },
    );
  };

  markAllRead = async (orgId: string, token: string) => {
    await this.client.post(`/user/notifications/${orgId}/read-all`, undefined, {
      headers: { Authorization: token },
    });
  };

  clearAll = async (orgId: string, token: string) => {
    await this.client.post(
      `/user/notifications/${orgId}/clear-all`,
      undefined,
      {
        headers: { Authorization: token },
      },
    );
  };
}

export default new NotificationsController(
  process.env.REACT_APP_API_URL_ENTERPRISE,
);
